<div class="material-slider">
	<div class="material-slider-container">
		<mat-slider
			[id]="sliderId + '-slider'"
			[min]="min"
			[max]="max"
			[step]="step"
			[value]="value"
			[disabled]="disabled"
			[thumbLabel]="showThumbLabel"
			color="primary"
			(input)="onInput($event)"
			(valueChange)="onValueChange($event)"
			[displayWith]="sliderLabelDisplayWith"
		></mat-slider>
	</div>
	<div class="material-slider-legends" [attr.disabled]="disabled">
		<ng-container *ngFor="let legend of legends">
			<span role="text" [id]="legend.id">{{legend.value}}</span>
		</ng-container>
	</div>
</div>
